// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"295":"batchquery","378":"singlequery","535":"login","596":"404","945":"mainlayout"}[chunkId] || chunkId) + "." + {"134":"3a4b7200","295":"f96b02c5","378":"68289f80","394":"f4772682","535":"29c4ff0b","596":"7fd0c26d","945":"6e2ae558"}[chunkId] + ".js";
};